import { Modal } from '@comptia-sso/core';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  errorMessage?: string;
  onClose: () => void;
};

export const ErrorModal = ({
  isOpen,
  errorMessage,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal title={t('ErrorModal.Title')} open={isOpen} onClose={onClose}>
      <p>
        {t('ErrorModal.Content')}
        {errorMessage}
      </p>
    </Modal>
  );
};
